import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  private authService = inject(AuthService);
  
  isScrolled = false;
  isMobileMenuOpen = false;
  cartCount = 0;

  currentUser$ = this.authService.currentUser$;

  logout() {
    this.authService.logout();
    this.closeMobileMenu();
  }

  navLinks = [
    { path: '/', label: 'Accueil', icon: '🏠' },
    { path: '/prescription/upload', label: 'Ordonnance', icon: '📋' },
    { path: '/catalog', label: 'Catalogue', icon: '💊' },
    { path: '/orders/track', label: 'Mes Commandes', icon: '📦' },
  ];

  @HostListener('window:scroll')
  onScroll() {
    this.isScrolled = window.scrollY > 30;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    if (this.isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
    document.body.style.overflow = '';
  }
}
